<template>
  <div class="rightCenterChart flex-row-sb">
    <Radar id="c2" path="kcl_pie" height="300px" width="100%"></Radar>
<!--    <div class="intro-item">-->
<!--      <ul class="ul-list flex-col-sb-c">-->
<!--        <li>-->
<!--          <p class="li-p color-1">¥256,474</p>-->
<!--          <div class="num flex-row&#45;&#45;c" style="margin-top: 10px">-->
<!--            <img style="width: 40px" src="~@/assets/large/color1.png" alt=""/>-->
<!--            <p style="margin-left: 5px" class="flex-col">-->
<!--              <span class="span-1">22%</span>-->
<!--              <span class="span-2">咳嗽</span>-->
<!--            </p>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li>-->
<!--          <p class="li-p color-3">¥256,474</p>-->
<!--          <div class="num flex-row&#45;&#45;c" style="margin-top: 10px">-->
<!--            <img style="width: 40px" src="~@/assets/large/color3.png" alt=""/>-->
<!--            <p style="margin-left: 5px" class="flex-col">-->
<!--              <span class="span-1">22%</span>-->
<!--              <span class="span-2">支气管炎</span>-->
<!--            </p>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li>-->
<!--          <p class="li-p color-5">¥256,474</p>-->
<!--          <div class="num flex-row&#45;&#45;c" style="margin-top: 10px">-->
<!--            <img style="width: 40px" src="~@/assets/large/color5.png" alt=""/>-->
<!--            <p style="margin-left: 5px" class="flex-col">-->
<!--              <span class="span-1">22%</span>-->
<!--              <span class="span-2">积食</span>-->
<!--            </p>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
<!--    <div id="rightCenterChart">-->
<!--      <Radar id="c2" path="kcl_pie" height="300px" width="100%"></Radar>-->
<!--    </div>-->
<!--    <div class="intro-item">-->
<!--      <ul class="ul-list flex-col-sb-c">-->
<!--        <li>-->
<!--          <p class="li-p color-2">¥256,474</p>-->
<!--          <div class="num flex-row&#45;&#45;c" style="margin-top: 10px">-->
<!--            <img style="width: 40px" src="~@/assets/large/color2.png" alt=""/>-->
<!--            <p style="margin-left: 5px" class="flex-col">-->
<!--              <span class="span-1">22%</span>-->
<!--              <span class="span-2">感冒</span>-->
<!--            </p>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li>-->
<!--          <p class="li-p color-4">¥256,474</p>-->
<!--          <div class="num flex-row&#45;&#45;c" style="margin-top: 10px">-->
<!--            <img style="width: 40px" src="~@/assets/large/color4.png" alt=""/>-->
<!--            <p style="margin-left: 5px" class="flex-col">-->
<!--              <span class="span-1">22%</span>-->
<!--              <span class="span-2">扁桃体炎</span>-->
<!--            </p>-->
<!--          </div>-->
<!--        </li>-->
<!--        <li>-->
<!--          <p class="li-p color-6">¥256,474</p>-->
<!--          <div class="num flex-row&#45;&#45;c" style="margin-top: 10px">-->
<!--            <img style="width: 40px" src="~@/assets/large/color6.png" alt=""/>-->
<!--            <p style="margin-left: 5px" class="flex-col">-->
<!--              <span class="span-1">22%</span>-->
<!--              <span class="span-2">少儿咳嗽</span>-->
<!--            </p>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>
</template>

<script>
import Radar from "@/views/charts/radar";

export default {
  name: "rightCenterChart",
  components: {
    Radar,
  },
  data() {
    return {};
  },
  mounted() {
  },
};
</script>
<style lang='scss' scoped>
.rightCenterChart {
  width: 100%;

  .intro-item {
    width: 100px;
    flex: 1;
  }

  #rightCenterChart {
    height: 330px;
    width: 45%;
  }

  .ul-list {
    height: 100%;
    padding-top: 20px;

    li {
      margin-bottom: 15px;

      .li-p {
        padding: 4px 0;
        width: 89px;
        font-size: 10px;
        text-align: center;
        border-radius: 4px;

        &.color-1 {
          background: rgba(252, 149, 59, 0.1);
          border: 1px solid #fc953b;
          color: #fc953b;
        }

        &.color-2 {
          background: rgba(245, 228, 71, 0.1);
          border: 1px solid #f5e447;
          color: #f5e447;
        }

        &.color-3 {
          background: rgba(0, 167, 255, 0.1);
          border: 1px solid #00a7ff;
          color: #00a7ff;
        }

        &.color-4 {
          background: rgba(126, 252, 96, 0.1);
          border: 1px solid #7efc60;
          color: #7efc60;
        }

        &.color-5 {
          background: rgba(96, 143, 252, 0.1);
          border: 1px solid #608ffc;
          color: #608ffc;
        }

        &.color-6 {
          background: rgba(96, 252, 178, 0.1);
          border: 1px solid #60fcb2;
          color: #60fcb2;
        }
      }

      .num {
        p {
          .span-1 {
            color: #fff;
            font-size: 17px;
            font-weight: bold;
          }

          .span-2 {
            font-size: 12px;
            color: #ffffff;
            opacity: 0.7;
          }
        }
      }
    }
  }
}
</style>
